import axios from 'axios';

import Model from '@/models/Model.js';
import QueryBuilder from '@/utilities/QueryBuilder.js';

export default class AnomalyDetectionResult extends Model {
    static entity = 'anomaly_detection_results';

    static modelName = 'AnomalyDetectionResult';

    static fields() {
        return {
            id: this.attr(null),
            anomaly_detection_id: this.attr(null),
            detectable_id: this.attr(null),
            detectable_type: this.attr(null),
            is_anomaly: this.attr(null),
            ks_stat: this.attr(null),
            p_value: this.attr(null),
            notes: this.attr(null),
            was_cheating_involved: this.attr(null),

            detectable: this.attr(null),
            classifiable: this.attr(null),
            classifiable_type: this.attr(null),
            anomaly_detection: this.attr(null),
            ...super.fields(),
        };
    }

    static queryBuilder() {
        return new QueryBuilder('anomaly-detection-results');
    }

    static searchable() {
        return ['groups', 'course_title', 'quiz_title', 'activity_title'];
    }

    /**
     * Update an anomaly detection result record
     * @param {Object} data - The data to update
     * @returns {Promise} - A promise that resolves with the updated anomaly detection result
     */
    static async axiosUpdate(data) {
        try {
            const response = await axios.put(`/api/anomaly-detection-results/${data.id}`, data);

            return response.data;
        } catch (error) {
            console.error('Error updating anomaly detection result:', error);
            throw error;
        }
    }
}
